module.exports = __webpack_public_path__ + "img/openbrowser.c998250e.png";